module.exports = __webpack_public_path__ + "img/border-rating.cdaa1285.svg";